import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/router/permission.js'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import * as echarts from 'echarts'
import 'echarts-wordcloud'


createApp(App).use(router).use(ElementPlus).mount('#app')

